<div [id]="id()" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <div class="relative max-h-full rounded-lg bg-primary-purple-light-2 lg:w-1/3 2xl:w-1/4">
        <div class="relative rounded-lg shadow p-8">
            <div class="flex items-center">
                <img [src]="visibilityIcon()" alt="visibility" class="h-6 w-6 mr-2 filter-primary-purple" />
                <h3 class="w-full text-lg font-bold">{{ literalService.get('suggestions.publicPreview.title', true) }}</h3>
                <button type="button" (click)="cancel()" class="absolute right-2 mr-2 rounded-lg w-8 h-8 inline-flex justify-center items-center cursor-pointer">
                    <img [src]="images.close" alt="close" class="h-6 w-6" />
                </button>
            </div>
            <p class="mt-4 text-base text-primary-purple">
                {{ literalService.get('suggestions.publicPreview.' + (suggestion()?.visibility ?? 'PASSENGERS'), true) }}
            </p>
            <article class="card bg-white mt-4 shadow-sm">
                <div class="card-body p-4 gap-2">
                    <div class="flex items-center gap-2 flex-wrap">
                        <span class="badge badge-error text-white">{{ typeLabel() }}</span>
                        <span class="font-semibold">{{ affairLabel() }}</span>
                    </div>
                    @if (serviceLabel()) {
                        <div class="flex items-center gap-2 text-sm">
                            <img [src]="images.suggestions.services" alt="service" class="h-4 w-4 filter-primary-purple-light" />
                            {{ serviceLabel() }}
                        </div>
                    }
                    <div class="flex items-center gap-2 text-sm">
                        <img [src]="images.suggestions.expedition" alt="expedition" class="h-4 w-4 filter-primary-purple-light" />
                        {{ expeditionLabel() || literalService.get('suggestions.publicPreview.wholeService', true) }}
                    </div>
                    <p class="text-base whitespace-pre-line mt-2">{{ suggestion()?.publicMessage }}</p>
                </div>
            </article>
            <div class="flex justify-center items-center mt-8 gap-4">
                <button type="button" class="secondary gap-4 px-4 border font-semibold h-11 w-full uppercase cursor-pointer" (click)="cancel()">{{ literalService.get('cancel', true) }}</button>
                <button type="button" class="primary text-white gap-4 px-4 border font-semibold h-11 w-full uppercase cursor-pointer" (click)="action.emit()">{{ literalService.get('suggestions.publicPreview.confirm', true) }}</button>
            </div>
        </div>
    </div>
</div>
